import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import ItemList from 'flarum/common/utils/ItemList';
import icon from 'flarum/common/helpers/icon';
import punctuateSeries from 'flarum/common/helpers/punctuateSeries';

import FeaturedBlogItem from 'flarum/v17development/blog/components/FeaturedBlogItem';
import BlogOverviewItem from 'flarum/v17development/blog/components/BlogOverviewItem';

import type Mithril from 'mithril';

export default function adjustBlogItems() {
  if (!FeaturedBlogItem || !BlogOverviewItem) {
    console.warn('[BHASVIC theme] Incompatible blog extension version: `FeaturedBlogItem` or `BlogOverviewItem` could not be imported');
    return;
  }

  function modifyItems(items: ItemList<Mithril.Children>) {
    if (items.has('author')) items.remove('author');
    if (items.has('replies')) items.remove('replies');

    const virtualAuthors = this.attrs.article.virtualAuthors();

    if (virtualAuthors?.length) {
      items.add(
        'virtualAuthors',
        <span>
          {icon('far fa-user')}
          {punctuateSeries(virtualAuthors.map((va: any) => va.displayName()))}
        </span>,
        20
      );
    }
  }

  extend(FeaturedBlogItem.prototype, 'dataItems', modifyItems);
  extend(BlogOverviewItem.prototype, 'dataItems', modifyItems);

  extend(BlogOverviewItem.prototype, 'dataItems', function (items: ItemList<Mithril.Children>) {
    items.add(
      'tags',
      <span class="BlogOverviewItem-Tags">
        {this.attrs.article.tags()?.map((tag) => (
          <span class="BlogOverviewItem-Tag">{tag.name()}</span>
        ))}
      </span>,
      1000
    );
  });
}
